import React, { useEffect, useRef } from 'react'
import { IconWarningCircleFilled } from '@dostavkee/web-ui'
import { toast } from 'sonner'

const TECHNICAL_PAUSE_TOAST_ID = 'technical-pause-alert'

const NetworkOfflineToast = () => {
    const title = __GLOBAL__?.VITE_TECHNICAL_PAUSE_TITLE ?? 'Ведутся технические работы'
    const message =
        __GLOBAL__?.VITE_TECHNICAL_PAUSE_MESSAGE ??
        'Совсем скоро всё заработает. Спасибо за терпение'

    return (
        <section>
            <strong>{title}</strong>
            <div>{message}</div>
        </section>
    )
}

export function TechnicalPauseAlert() {
    const toastIdRef = useRef<string | number | null>(null)

    useEffect(() => {
        if (__GLOBAL__?.VITE_TECHNICAL_PAUSE_ENABLED === 'true') {
            toastIdRef.current = toast.warning(<NetworkOfflineToast />, {
                id: TECHNICAL_PAUSE_TOAST_ID,
                duration: Infinity,
                icon: <IconWarningCircleFilled color='#dc7609' size={24} />,
            })
        }
    }, [])

    return null
}
